import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "16", "height": "16", "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "Group 7827" } }, [_c("path", { attrs: { "id": "Union", "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M9.58977 7.99967L14.4516 3.13787L12.8606 1.54687L7.99878 6.40868L3.13796 1.54785L1.54697 3.13884L6.40779 7.99967L1.54688 12.8606L3.13787 14.4516L7.99878 9.59066L12.8607 14.4525L14.4517 12.8616L9.58977 7.99967Z", "fill": "currentColor" } })])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const CloseIcon = __component__.exports;
export {
  CloseIcon as default
};
